import React, { useEffect } from "react";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import reportWebVitals from "./reportWebVitals";
import {
  updateServiceWorker,
  setServiceWorkerInitialized,
} from "./features/offline/offlineSlice";

import App from "./App";
import { store, persistor, generateStore } from "./store";
import { TourProvider } from "@reactour/tour";

import LocalStorageLogger from './LocalStorageLogger';

// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from './debugLog';

const Player = ({parentVersion, clientConfig}) => {

  const styles = {
    maskWrapper: (base) => ({
      ...base,
      color: 'black',
      opacity: 0.8
    }),
    popover:(base) => ({
      ...base,
      borderRadius: 5,
      margin: 5
    }),
    dot: (base) => ({ ...base, background: clientConfig.theme.colours.primary}),
    badge: (base) => ({ ...base, background: clientConfig.theme.colours.primary }),
  }


debugLog('22-sep-2025 Player.js parentVersion = ', parentVersion)


  return (
    <Provider store={store}>
      <PersistGate
  		loading={<div style={{ textAlign: 'center', marginTop: '2rem' }}>Loading state…</div>}
  		persistor={persistor}
		onBeforeLift={() => {
		  debugLog('Persisted state has loaded');
		  debugLog('Hydrated Redux state:', store.getState());
		}}

	  >
        <HashRouter>
          <TourProvider showBadge={false} showCloseButton={true} padding={0} wrapperPadding={0} styles={styles}>

			{/* safe to patch here */}
			<LocalStorageLogger />

            <App parentVersion={parentVersion} clientConfig={clientConfig}/>
          </TourProvider>
        </HashRouter>
      </PersistGate>
    </Provider>
  );


};

// pgw 15-sep-2025 - this does not work (i.e. songs do not play)
/*
const Player = ({ parentVersion, clientConfig }) => {
  const styles = {
    maskWrapper: (base) => ({ ...base, color: "black", opacity: 0.8 }),
    popover: (base) => ({ ...base, borderRadius: 5, margin: 5 }),
    dot: (base) => ({ ...base, background: clientConfig.theme.colours.primary }),
    badge: (base) => ({ ...base, background: clientConfig.theme.colours.primary }),
  };

  return (
    <HashRouter>
      <TourProvider
        showBadge={false}
        showCloseButton={true}
        padding={0}
        wrapperPadding={0}
        styles={styles}
      >
        <LocalStorageLogger />
        <App parentVersion={parentVersion} clientConfig={clientConfig} />
      </TourProvider>
    </HashRouter>
  );
};
*/



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

debugLog('15-sep-2025 Player.js not calling serviceWorkerRegistration.register')

/*

// pgw 10-aug-2025
debugLog('10-aug-2025 Player.js before call to serviceWorkerRegistration.register')




serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    debugLog("10-aug-2025 [SW] Registration successful:", registration);
    store.dispatch(setServiceWorkerInitialized(true));
  },
  onUpdate: (registration) => {
    debugLog("10-aug-2025 [SW] Update found:", registration);
    store.dispatch(updateServiceWorker(registration));
  }
});

debugLog('10-aug-2025 Player.js after call to serviceWorkerRegistration.register')
*/



export default Player;
